<template>
  <div id="app" class="min-h-screen bg-slate-900 text-white">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

onMounted(() => {
  // 应用启动时的初始化
  console.log('中卫算力中心项目进度监控系统启动')
})
</script>

<style>
/* 全局样式在 main.css 中定义 */
</style>